import "./StorefrontPreview.scss"
import React from "react"
import numeral from "numeral"
import { observer } from "mobx-react"
import { productStore, storefrontStore } from "../stores"

const StorefrontPreview = () => {
  const hasProducts = productStore.products.size > 0
  return (
    <div className="StorefrontPreview">
      <header className="StoreHeader">
        <img className="StoreHeader_image" src={storefrontStore.logo} alt="" />
        <h1 className="StoreHeader_name">{storefrontStore.name}</h1>
        <p className="StoreHeader_description">{storefrontStore.description}</p>
      </header>
      <ul className="ProductGrid">
        {hasProducts ? (
          productStore.products.values().map(product => (
            <li className="ProductGrid_item" key={product.id}>
              <div className="ProductCard">
                <div className="ProductCard_image">
                  <img src={product.images[0]} alt="" />
                </div>
                <div className="ProductCard_info">
                  <h5 className="ProductCard_name">{product.name}</h5>
                  <p className="ProductCard_color">{product.color}</p>
                  <p className="ProductCard_price">
                    {numeral(product.baseprice).format("$0.00")}
                  </p>
                </div>
              </div>
            </li>
          ))
        ) : (
          [1, 2].map(i => (
            <li className="ProductGrid_item">
              <div className="ProductGrid_blank" />
            </li>
          ))
        )}
      </ul>
    </div>
  )
}

StorefrontPreview.displayName = "StorefrontPreview"

export default observer(StorefrontPreview)



// WEBPACK FOOTER //
// ./src/storefront/StorefrontPreview.js